export default {
  'approver': {
    'search_title': 'Approver'
  },
  'on_road': {
    'report_number': 'Verification Report Number',
    'owner_name': 'Owner Name (Unit)',
    'owner_contact': 'Contact Number',
    'license_plate_number': 'License Plate Number',
    'vehicle_model': 'Vehicle Model',
    'inspection_result': 'Verification Result',
    'inspector': 'Inspector',
    'reviewer': 'Reviewer',
    'approver': 'Approver',
    'approval_date': 'Approval Date',
    'created_at': 'Creation Time',
    'updated_at': 'Update Time'
  }
}
